<template>
    <div class="select-date__container">
        <data :id="errorTarget"></data> 
        <div class="flatpickr">
            <input
                type="text"
                :name="name"
                :ref="name"
                :id="name"
                class="form-control form-control--select select-date__select-input select-date__select-input"
                :value="formattedDate"
                placeholder="Please select a date"
                data-validate="input" 
                :data-validate-message="validateMessage"
                :data-error-target="errorTarget"
            />
            <button type="button" class="input-button" @click="toggleDateSelect"></button>
        </div>
    </div>
</template>

<script>
import LoadingSpinner from "../../../core/components/LoadingSpinner.vue";

export default {
    components: {
        LoadingSpinner,
    },

    props: {
        selectedDate:{
            type:[Date,String]
        },
        maxDate: {
            type:Date,
            default: () => new Date(),
        },
        name: {
            type: String,
            required: true
        },
        validateMessage: {
            type: String,
            default: "Please select a date"
        },
        errorTarget: {
            type: String,
            default: "dateError"
        }
    },

    data() {
        return {
            flatpickrInstance: false,
            selected: '',
        };
    },

    computed: {
        formattedDate() {
            return this.selected ? new Date(this.selected).toDateString() : "";
        },
    },

    methods: {    
        initializeDatePicker() {
            if (this.flatpickrInstance !== false) {
                return;
            }
            this.selected = this.selectedDate
            this.flatpickrInstance = flatpickr(this.$refs[this.name], {
                minDate: this.minDate,
                maxDate: this.maxDate,
                altInput: false,
                dateFormat: "D J F Y",
                disableMobile: true,
                locale: {
                    firstDayOfWeek: 1,
                },
                onChange: ([selected]) => {
                    this.setSelectedDate(selected);
                },
            });
        },
        toggleDateSelect() {
            this.flatpickrInstance.open();
        },
        setSelectedDate(selectedDate) {
            this.selected = selectedDate;
            this.$emit('selected-date',  this.selected);
        },
    },

    mounted() {
        this.initializeDatePicker();
    },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// resources/assets/js/valuation-tool/components/Sections/SelectDate.vue